export default __webpack_public_path__ + "static/media/image_demo_prescription_delivery.05b0a6ec.svg";